<script setup></script>
<template>
  <div>
    <Head>
      <Html lang="en" />
      <Title>Kate O. Nahodyl, Artist</Title>

      <Meta name="msapplication-TileColor" content="#da532c" />
      <Meta name="theme-color" content="#ffffff" />
      <Meta
        name="description"
        content="Kate O. Nahodyl (she/her) is an Atlanta-area artist who uses acrylic and mixed media to create vibrant paintings in a style she refers to as 'Illustrated Impressionism.'"
      />
      <Meta name="keywords" content="fine art, acrylic, artist, Atlanta Artist" />
      <Meta name="author" content="Kate O. Nahodyl" />

      <Link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <Link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <Link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <Link rel="manifest" href="/site.webmanifest" />
      <Link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
    </Head>
    <div class="">
      <NavBar />
      <!--<FullWidthBanner class="mb-10" />-->
      <ContentWidthContainer>
        <main class="">
          <slot />
        </main>
      </ContentWidthContainer>
      <FooterBar />
    </div>
  </div>
</template>
